export function StopAction() {
	return null;
}
